/**
 * Roles permitted to operate a ticketbox till.
 *
 * Declared ONCE here because the set was previously duplicated in three places
 * — `LoginPage`'s post-login check, `RoleGate`'s route guard, and the
 * `UserRole` union in `types/auth` — and all three listed only the monolith's
 * lowercase names. A cashier authenticating against identity-service arrives as
 * `SALES`, so every one of those gates rejected a valid login: the POS accepted
 * the credentials, then bounced straight back to /login.
 *
 * Both vocabularies are listed because the app must work against either backend
 * for as long as the monolith-to-services migration runs:
 *
 *   monolith   services (`USER_ROLES` in @autopia/shared-types)
 *   ---------  ------------------------------------------------
 *   cashier    SALES
 *   subadmin   MANAGER / SUPERVISOR
 *   admin      ADMIN
 *   superadmin SUPER_ADMIN
 */
export const POS_ROLES: ReadonlySet<string> = new Set([
  // monolith
  'cashier',
  'superadmin',
  'admin',
  'subadmin',
  // services
  'SALES',
  'STAFF',
  'SUPERVISOR',
  'MANAGER',
  'ADMIN',
  'SUPER_ADMIN',
]);

/** True when `role` may operate a till, in either role vocabulary. */
export function canOperatePos(role: string | undefined | null): boolean {
  return Boolean(role && POS_ROLES.has(role));
}
